import React, { useState, useEffect, useContext} from "react"

import { usePDF, Resolution } from 'react-to-pdf';

import {
  Box,
  Container,
  Button,
  Hidden,
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/fr'

import MyModal from "../ui/MyModal"
import NewCertifChart from "./NewCertifChart"
import Rapport from "./Rapport"
import CloseIcon from '@mui/icons-material/Close';

import { nomCanonique } from "../../utils/skillsReferentiel"
import { alerteDuCandidat } from "../../utils/alerteTemps"

// Point 12 : la legende qui existait deja en page 2 du rapport PDF, reprise
// au-dessus du radar, plus le sens des pastilles ✓/✗ (explique nulle part).
const HexLegende = ({color}) => (
  <svg width="18" height="21" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M51.4648 15.2881V44.7109L25.9844 59.4229L0.503906 44.7109V15.2881L25.9844 0.576172L51.4648 15.2881Z" fill={color} fillOpacity="0.2" stroke={color}/>
  </svg>
)

const LegendeRadar = ({ type }) => {
  const entrees = [
    ...(type === "recruiter" ? [{ color:"#FED030", label:"Seuil requis" }] : []),
    { color:"#FF5106", label:"Innovation & communication" },
    { color:"#4F39FF", label:"Efficacité opérationnelle" },
    { color:"#F390FF", label:"Leadership & collaboration" },
  ]
  return (
    <Box sx={{
      display:"flex",
      flexWrap:"wrap",
      justifyContent:"center",
      alignItems:"center",
      columnGap:"18px",
      rowGap:"6px",
      paddingTop:"12px",
      userSelect:"none",
    }}>
      {entrees.map((entree, index) => (
        <Box key={index} sx={{display:"flex", alignItems:"center", gap:"7px"}}>
          <HexLegende color={entree.color}/>
          <Box sx={{fontSize:["12px", "13px", "14px"], color:"text.primary"}}>{entree.label}</Box>
        </Box>
      ))}
      {type === "recruiter" &&
        <Box sx={{fontSize:["12px", "13px", "14px"], color:"text.primary"}}>
          ✓ seuil du poste atteint · ✗ seuil du poste non atteint
        </Box>
      }
    </Box>
  )
}

const ViewResultsModal = ({ isOpen, user, actScan, onClose, type}) => {

  const getDatasForChart = (withoutTooltips) => {
    let labels = []
    let datasets = []
    let labelsDotColors = []
    let labelsIcons = []
    let labelsCategories = ['communication','efficacite','leadership']
    let softSkillsByFamily = actScan?.finalSoftSkills?.sort((a, b) => a?.family?.localeCompare(b?.family)); //on trie par famille (par nom de famille croissant)
    softSkillsByFamily?.forEach((skill) => {
      // Point 11 : le nom exact du referentiel, sans transformation de casse
      labels.push(nomCanonique(skill?.key))
      if (skill?.family === labelsCategories[0]) {
        labelsDotColors.push("rgba(255, 81, 6, 1)")
      } else if (skill?.family === labelsCategories[1]) {
        labelsDotColors.push("rgba(79, 57, 255, 1)")
      } else if (skill?.family === labelsCategories[2]) {
        labelsDotColors.push("rgba(243, 144, 255, 1)")
      }

    })

    let findResult
    let resultFin = null
    if (type === "recruiter") {
      findResult = actScan?.userResults?.find((el) => el.userID === user?.userID)
      try {
        resultFin = JSON.parse(findResult?.resultFin)
      } catch(e) {
        console.log(e)
        return null
      }
    } else if (type === "candidat") {
      try {
        resultFin = JSON.parse(user?.resultFin)
      } catch(e) {
        console.log(e)
        return null
      }
    }


    softSkillsByFamily?.forEach((skill) => {
      if (resultFin[skill.key]) {
        skill.score = resultFin[skill.key]?.score
      } else {
        skill.score = 0
      }

      //pour afficher les icones à coté des labels
      if (skill?.score < skill?.seuil) {
        labelsIcons.push("error")
      } else {
        labelsIcons.push(skill.family)
      }
    })

    let dashStyle = undefined
    labelsCategories?.forEach((cat, index) => {
      let arr = []
      let labelsNbr = 0
      softSkillsByFamily?.forEach((skill) => {
        if (skill.family === cat) {
          labelsNbr++
          if (resultFin[skill.key]) {
            arr.push(resultFin[skill.key]?.score)
          } else {
            arr.push(0)
          }
        } else {
          arr.push(0)
        }
      })


      let bgColor = ""
      let borderColor = ""
      let tooltipText = ""
      if (cat === labelsCategories[0]) {
        bgColor = "rgba(255, 81, 6, 0.2)"
        borderColor = "rgba(255, 81, 6, 1)"
        tooltipText = "Innovation et\ncommunication"
      } else if (cat === labelsCategories[1]) {
        bgColor = "rgba(79, 57, 255, 0.2)"
        borderColor = "rgba(79, 57, 255, 1)"
        tooltipText = "Éfficacité\nopérationnelle"
      } else if (cat === labelsCategories[2]) {
        bgColor = "rgba(243, 144, 255, 0.2)"
        borderColor = "rgba(243, 144, 255, 1)"
        tooltipText = "Collaboration et\nleadership"
      }


      datasets.push({
        title : index,
        data : arr,
        fill : true,
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
        tooltipText: tooltipText,
        labelsNbr : labelsNbr,
      })
    })

    //on regarde pour lier les lignes
    let indexLabels = 0
    for (let d=0; d<datasets.length; d++) {
      //pour le premier dataset
      if (d === 0 && datasets?.length >= 2) { //pour le premier dataset
        let actDataset = datasets[d]
        let nextDataset = datasets[d+1]

        actDataset.data[actDataset?.labelsNbr] = nextDataset.data[actDataset?.labelsNbr]
      } else if (d === datasets?.length-1) { //pour le dernier dataset
        let actDataset = datasets[d]
        let firstDataset = datasets[0]
        actDataset.data[0] = firstDataset.data[0]
      } else {
        let actDataset = datasets[d]
        let nextDataset =  datasets[d+1]
        actDataset.data[indexLabels + datasets[d]?.labelsNbr] = nextDataset.data[indexLabels + datasets[d]?.labelsNbr]
      }

      indexLabels += datasets[d]?.labelsNbr
    }

    if (type === "recruiter") {
      let seuilsArr = []
      softSkillsByFamily?.forEach((skill) => {
        seuilsArr.push(skill?.seuil)
      })
      datasets.push({
        title : "SEUILS",
        data : seuilsArr,
        fill : true,
        backgroundColor: "rgba(254, 208, 48, 0.2)",
        borderColor: "rgba(254, 208, 48, 1)",
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      })
    }

    /*console.log({
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : type === "recruiter" ? labelsIcons : false,
      withoutTooltips : withoutTooltips,
    })*/


    return {
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : type === "recruiter" ? labelsIcons : false,
      withoutTooltips : withoutTooltips,
    }
  }

  const getCompletedOn = () => {
    if (type === "recruiter") {
      let findResult = actScan?.userResults?.find((el) => el.userID === user?.userID)
      let momentDate = moment(findResult?.resultUpdatedAt)
      return `${momentDate.format('DD/MM/YYYY')} à ${momentDate.format('HH:mm')}`
    } else if (type === "candidat") {
      let momentDate = moment(user?.resultUpdatedAt)
      return `${momentDate.format('DD/MM/YYYY')} à ${momentDate.format('HH:mm')}`
    }
  }

  const getUserName = () => {
    if (type === "recruiter") {
      return user?.userName
    } else if (type === "candidat") {
      return user?.name
    }
  }

  const alerteTemps = type === "recruiter" ? alerteDuCandidat(
    actScan?.alertesTemps,
    user?.userID,
    actScan?.signauxNavigateur,
    { signauxDisponibles: actScan?.signauxNavigateurDisponibles, termineLe: actScan?.userResults?.find((el) => el.userID === user?.userID)?.resultUpdatedAt },
  ) : null

  const { toPDF, targetRef } = usePDF({
    //method: 'open',
    filename : "Rapport "+user?.userName+" - "+actScan?.module?.name+".pdf",
    resolution: 2,
    page: {
      orientation: "portrait",
      margin:0,
      format : [1250/4, 1768.0000001/4]
    },
    overrides: {
     /*canvas: {
       ignoreElements: function (element) {
         if (element.id === "closeButton" || element.id === "downloadButton" || element.id === "closeButtonVisible" || element.id === "downloadButtonVisible") {
           return true
         } else {
           return false
         }
      }
    },*/
   },
  });


  return (
    <>
      {isOpen &&
        <>
          {type === "recruiter" &&
            <Rapport
              ref={targetRef}
              user={user}
              getDatasForChart={getDatasForChart}
              actScan={actScan}
            />
          }
          <MyModal
            isOpen={isOpen}
            maxWidth="md"
            onClose={onClose}
            overflow="hidden"
            background="white"
          >
            <Box sx={{display:"flex", width:"100%", height:"100%", alignItems:"center", flexDirection:"column", overflow: alerteTemps ? "auto" : "hidden"}}>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
                // S5 : 15px laissait les libelles du radar ("Perseverance", "Consigne")
                // coller aux bords de la modale.
                // Point 5 : l'en-tete ne se compresse jamais — c'est le radar
                // qui s'adapte, pas le titre qui se fait couper.
                flexShrink:0,
                padding:["20px", "25px", "30px"],
                paddingBottom:["10px", "12px", "15px"],
                width:"100%",
                overflow:"hidden",
                userSelect:"none",
              }}>
                <Box sx={{
                  textAlign:"right"
                }}>
                  <CloseIcon onClick={onClose} sx={{
                    cursor:"pointer",
                    color:"text.black",
                    width:["25px", "35px", "35px"],
                    height:["25px", "35px", "35px"],
                  }}/>
                </Box>
                {/* Point 5 : les marges negatives glissaient le titre sous le
                    bord haut de la modale — la moitie superieure des lettres
                    etait coupee. Marge haute franche a la place. */}
                <Box sx={{
                  fontWeight:500,
                  color:"text.black",
                  fontSize:["28px", "36px", "42px"],
                  lineHeight:1.25,
                  paddingTop:["4px", "6px", "8px"],
                  overflow:"hidden",
                  whiteSpace:"nowrap",
                  textOverflow:"ellipsis",
                  textAlign:"center"
                }}>
                  {getUserName()}
                </Box>
              </Box>
              <Box sx={{
                color:"text.primary",
                fontWeight:400,
                fontSize:["15px", "16px", "18px"],
                flexShrink:0,
                overflow:"hidden",
                whiteSpace:"nowrap",
                textOverflow:"ellipsis",
                maxWidth:"calc(100% - 20px)"
              }}>
                <span style={{textTransform:"none"}}>Terminé le </span>
                {getCompletedOn()}
              </Box>
              {type === "recruiter" && alerteTemps &&
                <Box sx={{
                  flexShrink:0,
                  maxWidth:"calc(100% - 40px)",
                  marginTop:"10px",
                  padding:"8px 14px",
                  borderRadius:"8px",
                  background:"rgba(255, 244, 229, 1)",
                  color:"text.black",
                  fontSize:["13px", "14px", "15px"],
                  lineHeight:1.4,
                  textAlign:"center",
                }}>
                  <Box component="span" sx={{fontWeight:500}}>{alerteTemps.titre}.</Box>
                  {" "}{alerteTemps.details.join(". ")}{alerteTemps.details.length > 0 ? "." : ""}
                  {" "}{alerteTemps.note}
                </Box>
              }
              <Box sx={{flexShrink:0, maxWidth:"100%"}}>
                <LegendeRadar type={type}/>
              </Box>
              <Box sx={alerteTemps
                ? {flex:"0 0 auto", height:"700px", width:"100%", display:"flex", alignItems:"center"} /* hauteur DEFINIE : le radar se dimensionne dessus, la fenetre defile */
                : {flex:1, minHeight:0, width:"100%", display:"flex", alignItems:"center"}}>
                <Box sx={{width:"100%", height:"100%"}}>
                  <Hidden smDown>
                    <NewCertifChart
                      datas={getDatasForChart()}
                    />
                  </Hidden>
                  <Hidden smUp>
                    <NewCertifChart
                      datas={getDatasForChart()}
                      forMobile
                    />
                  </Hidden>
                </Box>
              </Box>
              {type === "recruiter" &&
                <Box sx={{paddingBottom:"15px"}}>
                  <MyButton
                    toPDF={toPDF}
                  />
                </Box>
              }
            </Box>
          </MyModal>
        </>
      }
    </>
  )
};

const MyButton = ({toPDF}) => {
  const [isCreatingPDF, setIsCreatingPDF] = useState(false)
  return (
    <Button
      variant="contained"
      disabled={isCreatingPDF}
      size={"medium"}
      onClick={async () => {
        if (isCreatingPDF === false) {
          setIsCreatingPDF(true)
          await toPDF()
          setIsCreatingPDF(false)
        }
      }}
    >
      Télécharger le rapport
    </Button>
  )
}

export default ViewResultsModal;
